// VaadPageContent.tsx
import React, { useEffect } from "react";
import SinglePageContainer from "../../../Common/SinglePageContainer";
import OverviewSection from "./OverviewSection";
import VaadTabs from "./VaadTabs";
import { useParams } from "react-router";
import {
  useVaadGetById,
  useVaadSendForm,
  useVaadStart,
} from "../../../../hooks/api/vaads";

import styles from "./index.module.scss";
import { useVaadTabs } from "./VaadTabs/context";
import { Button, message, Select } from "antd";
import { ExclamationCircleFilled, PlusCircleOutlined } from "@ant-design/icons";
import { useAuth, UserRoleType } from "../../../../store/auth";
import { getUserRequestPath } from "../../../../utils";
import { useSimpleModal } from "../../../Common/Modal/Simple";
import { useMessageError, useMessageSuccess } from "../../../../hooks/common";

export default function VaadPageContent() {
  const { id } = useParams();
  const { setVaadData, selectedMiddahId, setSelectedMiddahId } = useVaadTabs();
  const vaadGetById = useVaadGetById(id);
  const vaadStart = useVaadStart();
  const vaadSendForm = useVaadSendForm();
  const { user } = useAuth();
  const { open, contextHolder } = useSimpleModal();
  const isAdmin =
    !!user?.role && getUserRequestPath(user.role as UserRoleType) === "admin";

  const startVaad = async () => {
    if (!id) return;
    try {
      await vaadStart.fetch(undefined, `${id}/start`);
      // message.success("Vaad has been started successfully");
      vaadGetById.fetch();
    } catch {
      // message.error("Failed to start the vaad. Try again.");
    }
  };
  useMessageSuccess([vaadStart], "Vaad has been started successfully");
  useMessageError([vaadStart]);

  const handleStartVaad = () => {
    open({
      icon: <ExclamationCircleFilled />,
      title: "Start Vaad?",
      content: (
        <span>
          You are about to start the Vaad. All leads will receive registration
          links, all materials you have added will be shared. Do you want to
          continue?
        </span>
      ),
      cancelText: "Cancel",
      okText: "Start Vaad",
      onOk: startVaad,
    });
  };

  const sendForm = async () => {
    if (!id) return;
    try {
      const result = await vaadSendForm.fetch(undefined, `${id}/send-form`);
      message.success(
        result
          ? `Forms sent: ${result.sent} of ${result.total} users`
          : "Form has been sent successfully",
      );
      vaadGetById.fetch();
    } catch {
      // message.error("Failed to send the form. Try again.");
    }
  };
  useMessageError([vaadSendForm]);
  const handleSendForm = () => {
    open({
      icon: <ExclamationCircleFilled />,
      title: "Send Form?",
      content: (
        <span>
          All users in “New Lead” status will receive an email. Make sure a Type
          2 form is selected at this Vaad page at mussarvaad.org and meeting
          recording is uploaded.
          <br />
          Do you want to continue?
        </span>
      ),
      cancelText: "Cancel",
      okText: "Send Form",
      onOk: sendForm,
    });
  };

  useEffect(() => {
    if (vaadGetById.data) {
      setVaadData(vaadGetById.data);
    }
  }, [vaadGetById.data, setVaadData]);

  // Re-sync the selected middah whenever the opened vaad changes. The provider
  // lives at the app root and is never reset on navigation, so without this a
  // middah selected for a previously viewed vaad leaks into this one and shows
  // the wrong "currently studied" middah until a full page reload.
  useEffect(() => {
    setSelectedMiddahId(vaadGetById.data?.middah?.id);
  }, [vaadGetById.data?.id, setSelectedMiddahId]);

  const middahOptions =
    vaadGetById.data?.learnedMiddahs?.map((m) => ({
      label: m.middah.name,
      value: m.middah.id,
    })) || [];

  const titleWithMiddah = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <span>{vaadGetById.data?.name}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {isAdmin && vaadGetById.data?.status === "not_started" && (
          <Button
            type="primary"
            ghost
            loading={vaadSendForm.loading}
            onClick={handleSendForm}
          >
            Send Form
          </Button>
        )}
        {isAdmin && vaadGetById.data?.status === "not_started" && (
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            loading={vaadStart.loading}
            onClick={handleStartVaad}
          >
            Start Vaad
          </Button>
        )}
      </div>
      {/* <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 400 }}>Middah :</span>
        <Select
          value={selectedMiddahId}
          placeholder="Select middah"
          style={{ width: 200, fontWeight: 400 }}
          options={middahOptions}
          onChange={(value) => {
            setSelectedMiddahId(value);
          }}
        />
      </div> */}
    </div>
  );

  return (
    <SinglePageContainer
      title={titleWithMiddah}
      transparent
      noPadding
      cardLoading={vaadGetById.loading}
    >
      <div className={styles.container}>
        <OverviewSection />
        <VaadTabs />
      </div>
      {contextHolder}
    </SinglePageContainer>
  );
}
